import "./styles.css";
import Effect from "./pages/home/page";

export function NeonTimeTunnelHero() {
  return (
    <div className="special-effect-root" data-special-effect="neon-time-tunnel">
      <Effect />
    </div>
  );
}

export default NeonTimeTunnelHero;
